import { render, staticRenderFns } from "./CustomerOrder.vue?vue&type=template&id=455b4f66&scoped=true&"
import script from "./CustomerOrder.vue?vue&type=script&lang=js&"
export * from "./CustomerOrder.vue?vue&type=script&lang=js&"
import style0 from "./CustomerOrder.vue?vue&type=style&index=0&id=455b4f66&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "455b4f66",
  null
  
)

export default component.exports